import React, { useCallback } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@/components/common/ui/Button';
import Favorite from '@material-ui/icons/Favorite';
import styles from 'styles/jss/original/components/ideas/detailTitle';
import { FacebookShareButton, TwitterShareButton } from 'react-share';
import { IIdea } from '@/@types/generated/contentful';

// @ts-expect-error
const useStyles = makeStyles(styles);

type ComponentProps = {
  idea: IIdea;
  onRequestUpdateFavorite: (id: string) => void;
  isFavorite: boolean;
  invalid: boolean;
};

const DetailTitle: React.FC<ComponentProps> = ({
  idea,
  onRequestUpdateFavorite,
  isFavorite,
  invalid
}) => {
  const { id, title, slug, cat } = idea.fields;
  const classes = useStyles();
  const handleClick = useCallback(
    (id: string) => {
      onRequestUpdateFavorite(id);
    },
    [onRequestUpdateFavorite]
  );

  return (
    <div className={classes.section}>
      <div className={classes.container}>
        <ul className={classes.snsIcon}>
          <li className={classes.flexItem}>
            <TwitterShareButton
              url={`https://smalldish.jp/ideas/${slug}`}
              title={`${title} | smalldish`}
            >
              <Button color='white' round justIcon>
                <i className='fab fa-twitter' />
              </Button>
            </TwitterShareButton>
          </li>
          <li className={classes.flexItem}>
            <FacebookShareButton url={`https://smalldish.jp/ideas/${slug}`}>
              <Button color='white' round justIcon>
                <i className='fab fa-facebook-f' />
              </Button>
            </FacebookShareButton>
          </li>
        </ul>
        <h5 className={classes.category}>{cat}</h5>
        <h1 className={classes.title}>{title}</h1>
        <div className={classes.action}>
          <Button
            color='warning'
            round
            onClick={() => handleClick(id)}
            disabled={invalid}
            className={classes.flexItem}
          >
            <Favorite color={isFavorite ? 'secondary' : 'inherit'} />
            お気に入り
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DetailTitle;
